import { render, staticRenderFns } from "./polTypeStatsType.vue?vue&type=template&id=5c15cefe&"
import script from "./polTypeStatsType.vue?vue&type=script&lang=js&"
export * from "./polTypeStatsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports